export const POPOUT_V2_QUERY = 'popoutv2';
export const POPOUT_V2_VALUE = '1';

export const DEFAULT_POPOUT_MIN_HEIGHT = 600;
export const DEFAULT_POPOUT_MIN_WIDTH = 800;

export const CASCADE_POPOUT_LOOP_AFTER_COUNT = 8;
export const CASCADE_POPOUT_EVERY_OFFSET = 25;

export const POPOUT_LEAN_BOOTSTRAP_QUERY = 'leanbootstrap';
export const POPOUT_LEAN_BOOTSTRAP_VAULE = '1';
